import { WidgetContainer } from "../widget-container";
import { WidgetHeader } from "../widget-header";
import { WidgetContent } from "../widget-content";
import {
  useWidgets,
  useWidgetContextDispatch,
  ActionTypes,
} from "@hooks/use-widget-context";
import {
  WidgetContainerProps,
} from "@utils/asset-dashboard/types";
import { Box } from "@mui/material";

export const WidgetGrid = () => {
  const widgets = useWidgets();
  const dispatch = useWidgetContextDispatch();

  return (
    <Box
      data-testid="widget-grid"
      className="grid"
      sx={{
        display: "grid",
        // Mirrors the app's shared breakpoints (sm:600, md:900) instead of
        // the old JS-measured, independently-hardcoded 600px/1000px
        // thresholds — the browser handles the reflow natively.
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)",
          sm: "repeat(3, 1fr)",
          md: "repeat(4, 1fr)",
        },
        alignItems: "flex-start",
        width: "100%",
        padding: "12px 0",
      }}
    >
      {widgets.map((widget: WidgetContainerProps) => {
        return (
          <WidgetContainer
            key={widget.id}
            id={widget.id}
            type={widget.type}
            position={widget.position}
            config={widget.config}
          >
            <div className="content-container">
              <WidgetHeader
                onRemove={() => {
                  dispatch({
                    type: ActionTypes.REMOVE_WIDGET,
                    payload: widget.id,
                  });
                }}
                title={widget.config.title}
              />
              <WidgetContent widget={widget} />
            </div>
          </WidgetContainer>
        );
      })}
    </Box>
  );
};

export default WidgetGrid;
